import React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import cx from 'classnames';

type SelectTriggerProps = {
    id?: string;
    hasLabel: boolean;
    placeholder?: string;
    className?: string;
    ariaDescribedBy?: string;
    style?: React.CSSProperties;
    onFocus?: React.FocusEventHandler<HTMLButtonElement>;
    onBlur?: React.FocusEventHandler<HTMLButtonElement>;
    onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>;
    onKeyUp?: React.KeyboardEventHandler<HTMLButtonElement>;
};

const SelectTrigger = React.forwardRef<HTMLButtonElement, SelectTriggerProps>(
    ({ id, hasLabel, placeholder, className, ariaDescribedBy, style, onFocus, onBlur, onKeyDown, onKeyUp }, forwardedRef) => {
        return (
            <SelectPrimitive.Trigger
                ref={forwardedRef}
                id={id}
                style={style}
                aria-describedby={ariaDescribedBy}
                className={cx(
                    'flos-button',
                    'flos-button--secondary',
                    'flos-button--medium',
                    'flos-custom-select-trigger',
                    'flos-input',
                    !hasLabel && 'flos-custom-select-trigger--no-label',
                    className
                )}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                onKeyUp={onKeyUp}
            >
                <SelectPrimitive.Value placeholder={placeholder ?? 'Vælg...'} />
            </SelectPrimitive.Trigger>
        );
    }
);

SelectTrigger.displayName = 'SelectTrigger';

export { SelectTrigger };
